import React from "react";

const Privacy = () => {
  return (
    <>
      <div class="middle-section">
        <div class="container">
          <div class="cms-section">
            <div class="heading">
              <h2>Privacy</h2>
            </div>
            <div class="whitebox">
              <p>
                <strong>MyClubtap - Privacy Policy</strong>
              </p>
              <p>
                MyClubtap is committed to respect, protect and care about your
                privacy. Our policy is designed to provide transparency into our
                principles and privacy policies. This document explains further
                on how we treat any personal information that our members
                provide us about themselves and identify themselves as an
                individual.
              </p>
              <br></br>
              <p>
                <strong>The Types of Information We Collect</strong>
              </p>
              <p>
                MyClubtap may collect personal, club, league or anonymous
                information.
              </p>

              <ol>
                <li>
                  <p>
                    Registration information provided to create your ('member')
                    account, which includes your full name, address, phone
                    number, e-mail address, username (specific to use on our
                    website only) and password (specific to our website only);
                  </p>
                </li>
                <li>
                  <p>
                    Transaction information such as your address, telephone
                    number, payment information, that a club may provide while
                    paying us for the club's fantasy game;
                  </p>
                </li>
                <li>
                  <p>
                    Information you provide (and control whether to make it
                    public or not) on public forum (such as 'your profile');
                  </p>
                </li>
                <li>
                  <p>
                    Information you provide to link you to social networking
                    sites. You ('member') have the right to make it available to
                    public or not. We do not use this share or use this
                    information in any ways, other than to generate internal
                    reports or perform aggregate analysis;
                  </p>
                </li>
                <li>
                  <p>
                    Information on your location, usage, IP address, when you
                    visit our website. We do not share or use this information,
                    other than to generate internal reports or perform aggregate
                    analysis.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>How Will We Collect Your Information</strong>
              </p>
              <ol>
                <li>
                  <p>
                    We collect your information when you register with us,
                    respond to any surveys or any other interactions you may
                    have with us;
                  </p>
                </li>
                <li>
                  <p>
                    When you provide any information on a third-party site or
                    application, the information provided by you could be
                    separately collected by the third-party site or platform.
                    The information collected by us is covered by this policy
                    and the information collected by the third-party site or
                    platform's would be subjected to the third-party site or
                    platform's privacy policies respectively. Your privacy
                    choices made on the third-party sites or platform would not
                    apply to MyClubtap;
                  </p>
                </li>
                <li>
                  <p>
                    We may collect information through cookies or web beacons,
                    when you visit and/or use our website and applications. More
                    detailed information on the use of cookies and beacons can
                    be found here.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>How will we use Your Information</strong>
              </p>
              <p>MyClubtap may use your personal information as follows:</p>

              <ol>
                <li>
                  <p>
                    Use your name and profile photo to show your progress on the
                    leaderboard section of any fantasy game you have created a
                    team for;
                  </p>
                </li>
                <li>
                  <p>
                    Use your name to highlight you as the winner (if you happen
                    to win any fantasy game you have participated in) on our
                    website or our social media platforms;
                  </p>
                </li>
                <li>
                  <p>
                    Use your email address to communicate with you to provide
                    regular updates on the progress of any fantasy game you have
                    created a team for;
                  </p>
                </li>
                <li>
                  <p>
                    Use your player profile photo to show on the player card,
                    team pitch, player stats or wherever player related data is
                    displayed within the platform or screenshot shares on social
                    media; this can only be used if you have agreed to upload
                    your photo for your player profile or have requested your
                    Game Representative to do so on your behalf;
                  </p>
                </li>
                <li>
                  <p>
                    Provide you regular updates on our ongoing and upcoming
                    fantasy games;
                  </p>
                </li>
                <li>
                  <p>
                    We may use the information for reporting and analysis at our
                    end, to facilitate continued development of our website and
                    ensure continued improvements in the facilities we provide
                    you while you access our website;
                  </p>
                </li>
                <li>
                  <p>
                    Detect, investigate and mitigate any activities which may be
                    in violation of our policies or are found illegal;
                  </p>
                </li>
                <li>
                  <p>
                    We may send you information (via e-mail only) on their
                    product and services of our business partners, advertisers
                    or sponsors that may be of interest to you.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Sharing of Your Information</strong>
              </p>
              <ol>
                <li>
                  <p>
                    We do not share any of your personal information with our
                    Sponsors, Advertisers or Third-Party Applications or
                    Platforms;
                  </p>
                </li>
                <li>
                  <p>
                    We may share non-personal details, only in terms of
                    aggregate numbers to show the numbers of members of our
                    website (for eg. say 100 members visited us in the past one
                    week, but not say that 'John' visited us 2 times in a day);
                  </p>
                </li>
                <li>
                  <p>
                    Information that is sent-received during your communication
                    using 'chat' functionality through your profile with other
                    members, is not made accessible to anyone or used in any
                    ways by MyClubtap.
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>To Access and Update Your Information</strong>
              </p>
              <ol>
                <li>
                  <p>
                    You (member) would have access to your personal information
                    (via 'My Account') that you may have provided to us;
                  </p>
                </li>
                <li>
                  <p>
                    You would have the required access to made edit(s) to your
                    personal information at any times;
                  </p>
                </li>
                <li>
                  <p>
                    You may choose whether you would like to receive from us any
                    offers and promotions related to any live or upcoming games;
                  </p>
                </li>
                <li>
                  <p>
                    You have the option to allow or refrain us from sending any
                    marketing related information (related to us 'MyClubtap' or
                    'Sponsors');
                  </p>
                </li>
                <li>
                  <p>
                    You can request access to your personal information we hold
                    and request for it to be amended or deleted (you can do so
                    by contacting us via e-mail on admin@myclubtap.com)
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>Payment Related Information</strong>
              </p>
              <p>We take care to make Our Website safe for you to use.</p>
              <ol>
                <li>
                  <p>
                    Card payments are not processed through pages controlled by
                    us. We use one or more online payment service providers who
                    will encrypt your card or bank account details in a secure
                    environment.
                  </p>
                </li>
              </ol>
              <p>
                If you have asked us to remember your credit card details in
                readiness for your next purchase or subscription, we will
                securely store your payment details on our systems. These
                details will be fully encrypted and only used to process your
                other transactions which you have initiated.
              </p>
              <ol>
                <li>
                  <p>
                    For any information you may need related to your payment of
                    a fee paid for a club's fantasy game on MyClubtap, please
                    contact us via e-mail on{" "}
                    <a href="mailto:admin@myclubtap.com">admin@myclubtap.com</a>
                    .
                  </p>
                </li>
              </ol>
              <br></br>
              <p>
                <strong>
                  Links to Our Market Partners, Advertisers or Sponsors
                </strong>
              </p>
              <ol>
                <li>
                  <p>
                    Our website may have links to re-direct you towards our
                    'Advertisers' or 'Sponsors' websites and/or promotions.
                    Please ensure to read through their privacy policy before
                    further use of those websites;
                  </p>
                </li>
                <li>
                  <p>
                    We do not control or are responsible for any
                    content/information available on the re-directed links.
                    However, we are at all times vigilant of not allowing any
                    unrelated information to be made available to you (the
                    'members'). If you happen to come across any such
                    information, please report it immediately to us on
                    admin@myclubtap.com, so that immediate steps can be taken to
                    correct the reported links.
                  </p>
                </li>
              </ol>

              <p>
                MyClubtap reserves all rights (without any warning) to
                investigate and/or remove any persons individual team or club
                from accessing its website (and servers) and/or blocking the
                concerned accounts, if we at our sole discretion have
                substantiate information on you violating any of these laid
                terms of use, privacy policy and/or any application laws.
              </p>
              <br></br>
              <p>
                <strong>Data Security, Integrity and Retention</strong>
              </p>
              <p>
                To maintain the security, integrity and confidentiality of your
                information is of paramount importance to us. We have ensured to
                implement measures to protect our guests from any unauthorized
                access. We continue to review our security procedures from time
                to time and necessary modifications are made in technology as
                required. Please be advised that despite our sincere efforts, no
                security measures are perfect or impassable.
              </p>
              <br></br>
              <p>
                <strong>Changes to This Privacy Policy</strong>
              </p>
              <p>
                We may change this privacy policy with changes in recent
                technologies, best industry practices, regulatory requirements
                or for other purposes. We reserve the right to change the terms
                of this policy, of which you would only be informed, and/or
                obtain your consent where applicable by law.
              </p>
              <br></br>
              <p>
                <strong>Comments and Questions</strong>
              </p>
              <p>
                If you have any comments or questions about this privacy policy,
                please contact us via e-mail at admin@myclubtap.com.
              </p>
              <br></br>
              <p>
                <strong>Definitions</strong>
              </p>

              <p>
                <strong>Aggregate Information:</strong> Means information about
                a group of members, but cannot identify an individual member.
              </p>

              <p>
                <strong>Anonymous Information:</strong> Means information where
                a member cannot be identified as an individual.
              </p>

              <p>
                <strong>Application:</strong> Means a program or service
                operated by a club, league or association which may be displayed
                on various mobile, online or other platforms, which enable us to
                interact directly with our members.
              </p>

              <p>
                <strong>IP Address:</strong> Means the address associated with
                the access point of our members over the internet. It is not
                controlled by us, but controlled by the Internet Service
                Provider of the member. We use the information for reporting and
                analysis purposes only.
              </p>

              <p>
                <strong>Personal Information:</strong> Means the information
                which can enable us to identify a member. It includes member's
                name, address, e-mail address, phone number.
              </p>

              <p>
                <strong>Public Forum:</strong> Means the chat/message boards,
                social media environments and profile pages that may not have
                restricted audience. When a member provides his/her personal
                information on it, the information is open for access for all
                other members.
              </p>

              <p>
                <strong>member:</strong> Means a person who has registered with
                us on our website and may be participating in one of our
                competitions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
